import { DOCUMENT, inject, Injectable } from '@angular/core';
import { Platform } from '@angular/cdk/platform';

import { detectDeviceType, detectIsMacOs } from '../utils-fn/device-type.utils';
import { DeviceDetectorState, DeviceInfo } from '../data-access/store/device-detector.state';

@Injectable({ providedIn: 'root' })
export class DeviceDetectorService {
  readonly #platform = inject(Platform);
  readonly #document = inject(DOCUMENT);

  detect(): DeviceDetectorState {
    const device = detectDeviceType(this.#document);
    return {
      platform: this.detectPlatform(),
      deviceType: device.deviceType,
      isTabletBreakpoint: device.isTabletBreakpoint,
      nativeAppType: device.nativeAppType,
      isMacOs: detectIsMacOs(this.#document.defaultView?.navigator),
    };
  }

  detectDeviceType(): DeviceInfo {
    return detectDeviceType(this.#document);
  }

  private detectPlatform(): (keyof Platform)[] | null {
    const matches = Object.entries(this.#platform).filter(([key, value]) => value === true);
    return matches ? matches.map((m) => m[0] as keyof Platform) : null;
  }
}
